import stockIconOK from "../assets/icons/stock_ok.svg";
import stockIconWarn from "../assets/icons/stock_warn.svg";
import stockIconTime from "../assets/icons/stock_time.svg";
import stockIconEmpty from "../assets/icons/stock_empty.svg";
import stockIconUnknown from "../assets/icons/stock_unknown.svg";
import { useLang } from "../hooks/LangHooks";
import { useMemo, useRef } from "react";
import { useTooltip } from "./ToolTip";

const StockIcon = ({ stockStatus }) => {
  return stockStatus.icon === "ok" ? (
    <img src={stockIconOK} className="icon" alt="✓" />
  ) : stockStatus.icon === "warn" ? (
    <img src={stockIconWarn} className="icon" alt="⚠" />
  ) : stockStatus.icon === "time" ? (
    <img src={stockIconTime} className="icon" alt="⧖" />
  ) : stockStatus.icon === "empty" ? (
    <img src={stockIconEmpty} className="icon" alt="x" />
  ) : (
    <img src={stockIconUnknown} className="icon" alt="?" />
  );
};

const StockStatus = ({ stockStatus, sku }) => {
  const lang = useLang();
  const tooltipParent = useRef();
  const tooltipContent = useMemo(
    () => (
      <>
        <div>
          <StockIcon stockStatus={stockStatus} /> {stockStatus.message}
        </div>
        {!!stockStatus.amount && (
          <div className={"mt-2"}>{stockStatus.amount}</div>
        )}
      </>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lang, stockStatus.icon, stockStatus.message]
  );
  useTooltip(tooltipParent, tooltipContent);
  return (
    <div className="stock-status" id={"stockIcon" + sku} ref={tooltipParent}>
      <StockIcon stockStatus={stockStatus} />
    </div>
  );
};

export default StockStatus;
